import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocumentIdState } from './document-id.model';

const selectState = createFeatureSelector<DocumentIdState>('documentState');

export const selectDocumentIdState = createSelector(
  selectState,
  (state: DocumentIdState) => state
);

export const selectDocumentIdFields = createSelector(
  selectState,
  (state: DocumentIdState) => state?.documentFields
);
